module.exports = __webpack_public_path__ + "img/Big Picture Thinker.b5aa0502.svg";